export const NomineesEnum = {
    "relationship_others": "Others",
    "relationship_mother": "Mother",
    "relationship_father": "Father",
    "relationship_nan": "NAN",
    "DELETECANCEL": "DELETECANCEL",
    "NOMINEE_1": "NOMINEE 1",
    "NOMINEE_2": "NOMINEE 2",
    "OKCANCEL": "OKCANCEL"
};